// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import AssignmentResolverController from "./assignment_resolver_controller"
application.register("assignment-resolver", AssignmentResolverController)

import AutoScrollController from "./auto_scroll_controller"
application.register("auto-scroll", AutoScrollController)

import BulkSelectionController from "./bulk_selection_controller"
application.register("bulk-selection", BulkSelectionController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import CheckboxesController from "./checkboxes_controller"
application.register("checkboxes", CheckboxesController)

import ChoicesController from "./choices_controller"
application.register("choices", ChoicesController)

import ChoroplethChartController from "./choropleth_chart_controller"
application.register("choropleth-chart", ChoroplethChartController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import ColorPickerFieldController from "./color_picker_field_controller"
application.register("color-picker-field", ColorPickerFieldController)

import ConflictCheckerController from "./conflict_checker_controller"
application.register("conflict-checker", ConflictCheckerController)

import DateRangePickerController from "./date_range_picker_controller"
application.register("date-range-picker", DateRangePickerController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ElementRemoverController from "./element_remover_controller"
application.register("element-remover", ElementRemoverController)

import EmptyFieldCheckerController from "./empty_field_checker_controller"
application.register("empty-field-checker", EmptyFieldCheckerController)

import EscapiaReviewsDeleteController from "./escapia_reviews_delete_controller"
application.register("escapia-reviews-delete", EscapiaReviewsDeleteController)

import FiltersController from "./filters_controller"
application.register("filters", FiltersController)

import FormBlockerController from "./form_blocker_controller"
application.register("form-blocker", FormBlockerController)

import FormPreviewerController from "./form_previewer_controller"
application.register("form-previewer", FormPreviewerController)

import FrameLoaderController from "./frame_loader_controller"
application.register("frame-loader", FrameLoaderController)

import GaEventController from "./ga_event_controller"
application.register("ga-event", GaEventController)

import GlobalUserCompaniesSearchController from "./global_user_companies_search_controller"
application.register("global-user-companies-search", GlobalUserCompaniesSearchController)

import CustomFieldPickerController from "./custom_field_picker_controller"
application.register("custom-field-picker", CustomFieldPickerController)

import HidePanelController from "./hide_panel_controller"
application.register("hide-panel", HidePanelController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import ImgFixerController from "./img_fixer_controller"
application.register("img-fixer", ImgFixerController)

import InputFillerController from "./input_filler_controller"
application.register("input-filler", InputFillerController)

import UnitMentionController from "./unit_mention_controller"
application.register("unit-mention", UnitMentionController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import ListingMappingsController from "./listing_mappings_controller"
application.register("listing-mappings", ListingMappingsController)

import MarkdownController from "./markdown_controller"
application.register("markdown", MarkdownController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import OwnerRezController from "./owner_rez_controller"
application.register("owner-rez", OwnerRezController)

import PopUpOpenerController from "./pop_up_opener_controller"
application.register("pop-up-opener", PopUpOpenerController)

import PrintController from "./print_controller"
application.register("print", PrintController)

import RatingController from "./rating_controller"
application.register("rating", RatingController)

import ReloadConfirmerController from "./reload_confirmer_controller"
application.register("reload-confirmer", ReloadConfirmerController)

import ReplyNavigatorController from "./reply_navigator_controller"
application.register("reply-navigator", ReplyNavigatorController)

import ReservationDatepickerController from "./reservation_datepicker_controller"
application.register("reservation-datepicker", ReservationDatepickerController)

import RevaExtensionCheckerController from "./reva_extension_checker_controller"
application.register("reva-extension-checker", RevaExtensionCheckerController)

import ReviewsWebsiteDisplayController from "./reviews_website_display_controller"
application.register("reviews-website-display", ReviewsWebsiteDisplayController)

import ScrollLockController from "./scroll_lock_controller"
application.register("scroll-lock", ScrollLockController)

import ScrollerController from "./scroller_controller"
application.register("scroller", ScrollerController)

import SectionTogglerController from "./section_toggler_controller"
application.register("section-toggler", SectionTogglerController)

import SelectFilterController from "./select_filter_controller"
application.register("select-filter", SelectFilterController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import StreamCatchUpController from "./stream_catch_up_controller"
application.register("stream-catch-up", StreamCatchUpController)

import SubmitFormController from "./submit_form_controller"
application.register("submit-form", SubmitFormController)

import TableDeleterController from "./table_deleter_controller"
application.register("table-deleter", TableDeleterController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TaskFilterController from "./task_filter_controller"
application.register("task-filter", TaskFilterController)

import TippyController from "./tippy_controller"
application.register("tippy", TippyController)

import ToggleSectionController from "./toggle_section_controller"
application.register("toggle-section", ToggleSectionController)

import TruncateTextController from "./truncate_text_controller"
application.register("truncate-text", TruncateTextController)

import TurboLoaderController from "./turbo_loader_controller"
application.register("turbo-loader", TurboLoaderController)

import UrlValidatorController from "./url_validator_controller"
application.register("url-validator", UrlValidatorController)

import WidgetFilterController from "./widget_filter_controller"
application.register("widget-filter", WidgetFilterController)

import WordCloudController from "./word_cloud_controller"
application.register("word-cloud", WordCloudController)
